import { Component, inject, OnInit } from '@angular/core';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { ManuallyComponent } from './manually/manually.component';
import { ImportUsersComponent } from './import-users/import-users.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { BehaviorSubject, finalize, map } from 'rxjs';
import { Role, RoleService } from '../../../../shared/services/role.service';

@Component({
  selector: 'app-add-user',
  standalone: true,
  imports: [
    NzTabsModule,
    ManuallyComponent,
    ImportUsersComponent,
    NzButtonModule,
  ],
  templateUrl: './add-user.component.html',
  styleUrl: './add-user.component.scss',
})
export class AddUserComponent implements OnInit {
  private readonly roleService = inject(RoleService);
  roleList$ = new BehaviorSubject<Role[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  isOptionsLoading$ = this.loadingSubject.asObservable();

  ngOnInit() {
    this.getRoles();
  }

  private getRoles(): void {
    this.loadingSubject.next(true);

    this.roleService
      .getAllRoles()
      .pipe(
        map(response =>
          response.result.map(role => ({
            id: role.id,
            name: role.name,
          }))
        ),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(roles => {
        this.roleList$.next(roles);
      });
  }
}
